module.exports = __webpack_public_path__ + "static/media/quality-slide3.3ddefcd2.jpg";